export enum UserRolesEnum {
  User = 'user_FA',
  Admin = 'admin_FA',
  Auditor = 'audit_FA',
  Planning = 'planing_FA',
  RefundTeam = 'refund_FA',
  AppAdmin = 'appAdmin',
}
